import {useMediaQuery} from '@mui/material'
import {FC, MutableRefObject} from 'react'
import {InterestsModal} from 'widgets/interestsModal'
import {NewPasswordModal} from 'widgets/newPasswordModal'
import {VirtualizedUserList} from 'widgets/virtualizedUserList'
import styles from './styles.module.scss'
import {SearchPeople} from './ui/searchPeople'


export const PeoplePage: FC<{wrapperRef: MutableRefObject<HTMLDivElement | null>}> = ({wrapperRef}) => {
  const isMobile = useMediaQuery(`(max-width: ${styles.isMobile})`)

  return (
    <>
      {!isMobile ? <SearchPeople /> : null}
      <VirtualizedUserList isPeoplePage ref={wrapperRef} />
      <NewPasswordModal />
      <InterestsModal canSkip />
    </>
  )
}

// TODO: Почему именно People page?